import {FACTIONS} from "../../../constants/factions";

export const VENTORY_QUOTES = [{
  quote: 'Золото тише шпиона, быстрее стрелы и убедительнее любого пророка',
  author: 'Мамерк Маргинал, гильд-мастер Венторийской Теневой биржи',
  factionId: FACTIONS.VENTORY
}, {
  quote: 'Культура — это когда враг сам платит за то, чтобы стать твоим союзником',
  author: 'Публий Цест, вентори-коллектор Имперских задолженностей',
  factionId: FACTIONS.VENTORY
}, {
  quote: 'Никто не помнит имени полководца, который сжёг город. Все помнят имя того, кто его отстроил — и продал обратно',
  author: 'Секст Эмпорий, первый единоличный владелец Венторийского Центрального базара',
  factionId: FACTIONS.VENTORY
}, {
  quote: 'Вы продаёте мечи. Мы продаём причины, чтобы мечи не понадобились. Но если понадобятся — у нас есть и мечи',
  author: 'Сервий Силлий, старший нотариус Венторийской гильдии Честных Сделок',
  factionId: FACTIONS.VENTORY
}, {
  quote: 'Золото — это кровь войны. Мы просто переливаем кровь из одного тела в другое. С комиссией',
  author: 'Ливия Арс, первый посол вентори в Римской империи',
  factionId: FACTIONS.VENTORY
}, {
  quote: 'Договор стоит дороже крови. Кровь проливается один раз. Договор кормит годами',
  author: 'Маний Форум, основатель Венторийской Торговой Лиги',
  factionId: FACTIONS.VENTORY
}, {
  quote: 'Наёмники не предают. Они просто пересматривают условия контракта. Чаще в нашу пользу',
  author: 'Тиберий Коллат, вентори, подписавший первый контракт с людьми',
  factionId: FACTIONS.VENTORY
}, {
  quote: 'Город, купленный за золото, дешевле города, взятого осадой. И он быстрее начинает платить налоги',
  author: 'Гай Меркатор, глава Венторийской Торговой палаты',
  factionId: FACTIONS.VENTORY
}]